import React from "react";
import { Spin } from "antd";
import { Localize } from "components/service";
import { getStaffCheckInProvenance } from "../helpers/staff-check-in-provenance-helper";


const StaffCheckInProvenanceField = ({ event, kind, loading = false, children }) => {
    const { actor, source, date, unavailableDateKey } = getStaffCheckInProvenance(event, kind);

    return (
        <div className="staff-check-in-provenance" aria-live="polite" aria-busy={ loading }>
            <span className="staff-check-in-provenance__label">
                <Localize>{ kind === "qr" ?
                    "STAFF_MANAGEMENT.Provenance_Created" : "STAFF_MANAGEMENT.Provenance_LastSet" }</Localize>
            </span>
            <span className="staff-check-in-provenance__details">
                { loading ? <Spin size="small" /> : <>
                    { actor && <Localize name={ actor }>STAFF_MANAGEMENT.Provenance_By</Localize> }
                    { source && <>
                        { actor ? " (" : "" }
                        <Localize>{ source === "APP" ?
                            "STAFF_MANAGEMENT.Provenance_FromApp" : "STAFF_MANAGEMENT.Provenance_FromCrm" }</Localize>
                        { actor ? ")" : "" }
                    </> }
                    { !actor && !source && <Localize>STAFF_MANAGEMENT.Provenance_Unavailable</Localize> }
                    { " | " }
                    { date || <Localize>{ unavailableDateKey }</Localize> }
                </> }
            </span>
            { children }
        </div>
    );
};

export default StaffCheckInProvenanceField;
